/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var moveYAfterX = function moveYAfterX(array, from, to) {
  if (!Array.isArray(array)) {
    array = [];
  }
  var result = [].concat(array);
  var len = array.length;
  if (from === to || !len || from == null || to == null || from >= len || to > len) {
    return result;
  }
  from = Array.isArray(from) ? from : [from];
  var values = from.map(function (index) {
    return array[index];
  }).reverse();
  var emptyArray = [];
  emptyArray.concat(from).sort(function (a, b) {
    return b - a;
  }).forEach(function (index) {
    result.splice(index, 1);
  });
  from.reverse().forEach(function (_, i) {
    result.splice(to, 0, values[i]);
  });
  return result;
};
var _default = moveYAfterX;
exports.default = _default;